import React from "react";
import bg from "../../assets/assets/bgimage.jpg";
import { MessageSquareText, FileSpreadsheet, FileArchive, CreditCard, Clock } from "lucide-react";

export const JUST_ASK_VI_URL = "https://justaskvi.com";

const Hero = () => {
  const heroData = {
    mainTitle: "Just Ask VI",
    subtitle: "Private company financials on demand. Name the companies you need, pay per company and download instantly.",
    differentiators: [
      { icon: <MessageSquareText size={18} className="md:w-6 md:h-6" />, title: "Just type the company names" },
      { icon: <FileSpreadsheet size={18} className="md:w-6 md:h-6" />, title: "Latest P&L, Balance Sheet & Cash Flow in Excel" },
      { icon: <FileArchive size={18} className="md:w-6 md:h-6" />, title: "Annual reports in one ZIP" },
      { icon: <CreditCard size={18} className="md:w-6 md:h-6" />, title: "₹600 + GST per company, no subscription" },
      { icon: <Clock size={18} className="md:w-6 md:h-6" />, title: "Files ready right after payment", centered: true }
    ]
  };

  return (
    <div className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-12 md:py-20">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div className="relative z-10 container mx-auto px-5 md:px-7 flex flex-col">
        <div className="max-w-5xl mx-auto space-y-10 md:space-y-14 text-center">
          <div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
              <span className="text-[#efefef]">{heroData.mainTitle}</span>
            </h1>
            <p className="text-base md:text-lg text-gray-200 max-w-2xl mx-auto">{heroData.subtitle}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto px-3">
            {heroData.differentiators.slice(0, 4).map((item, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-xl p-3 md:p-5
                         hover:bg-white/15 transition-all duration-300 flex items-center gap-3 md:gap-5
                         shadow-md hover:shadow-lg transform hover:-translate-y-1"
              >
                <div className="bg-[#c59c40] rounded-lg p-1.5 md:p-2.5 text-white">
                  {item.icon}
                </div>
                <h3 className="text-sm md:text-base text-white font-semibold text-left">
                  {item.title}
                </h3>
              </div>
            ))}

            <div
              className="col-span-1 md:col-span-2 bg-white/10 backdrop-blur-sm border border-white/10
                       rounded-xl p-3 md:p-5 hover:bg-white/15 transition-all duration-300
                       flex items-center justify-center gap-3 md:gap-5 max-w-md mx-auto mt-3 md:mt-4
                       shadow-md hover:shadow-lg transform hover:-translate-y-1"
            >
              <div className="bg-[#c59c40] rounded-lg p-1.5 md:p-2.5 text-white">
                {heroData.differentiators[4].icon}
              </div>
              <h3 className="text-sm md:text-base text-white font-semibold">
                {heroData.differentiators[4].title}
              </h3>
            </div>
          </div>

          <div>
            <a
              href={JUST_ASK_VI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 bg-[#bc8b20] text-white rounded-md hover:bg-[#d6b15f] transition-colors duration-300 font-medium"
            >
              Try Just Ask VI
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
